import StepperTabButton from './StepperTabButton';
import { ReactNode } from 'react';

export interface StepperTab<T = any> {
    label: ReactNode;
    tab: T;
    rightIcon?: ReactNode;
    disabled?: boolean;
    title?: string;
}

interface StepperTabsProps<T = any> {
    steps: StepperTab<T>[];
    currentTab: T;
    setTab: (tab: T) => void;
    goTo?: (tab: T) => void;
}

export default function StepperTabs<T = any>({ steps, currentTab, setTab, goTo }: StepperTabsProps<T>) {
    return (
        <div className='stepper-wrapper'>
            {steps.map((step: StepperTab<T>) => (
                <StepperTabButton
                    key={String(step.tab)}
                    label={step.label}
                    isSelected={currentTab === step.tab}
                    rightIcon={step.rightIcon}
                    disabled={step.disabled}
                    title={step.title}
                    onClick={() => {
                        if (!step.disabled) {
                            setTab(step.tab);
                            if (goTo) goTo(step.tab);
                        }
                    }}
                />
            ))}
        </div>
    );
}
